import SHOrgTree from './src/tree.vue';

/* istanbul ignore next */
SHOrgTree.install = function(Vue) {
  Vue.component('sh-org-tree', SHOrgTree);
};

export default SHOrgTree;



// WEBPACK FOOTER //
// ./src/components/base/view/Org/cmps/org/tree/index.js